import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConstantProvider {

  // public static apiURL = 'https://app.invisiblecity.org.au';
  public static apiURL = environment.server;
  //To display map in grey color(silver theme)
  public mapStyle: any = [
    {
      featureType: 'all',
      elementType: 'all',
      stylers: [
        {
          saturation: '-100'
        }
      ]
    },
    {
      featureType: 'administrative',
      elementType: 'all',
      stylers: [
        {
          saturation: '-100'
        }
      ]
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [
        {
          saturation: '-100'
        },
        {
          lightness: '14'
        }
      ]
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on'
        },
        {
          saturation: '-100'
        },
        {
          gamma: '1'
        }
      ]
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [
        {
          saturation: '-100'
        },
        {
          visibility: 'simplified'
        }
      ]
    },
    {
      featureType: 'poi',
      elementType: 'geometry.fill',
      stylers: [
        {
          saturation: '-100'
        },
        {
          lightness: '60'
        }
      ]
    },
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [
        {
          saturation: '-100'
        },
        {
          weight: '6.61'
        },
        {
          lightness: '0'
        },
        {
          gamma: '1.5'
        }
      ]
    },
    {
      featureType: 'poi',
      elementType: 'labels.icon',
      stylers: [
        {
          saturation: '-100'
        },
        {
          gamma: '1.5'
        },
        {
          weight: '0.01'
        }
      ]
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#e3e3e3'
        }
      ]
    },
    {
      featureType: 'road',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'road.highway',
      elementType: 'all',
      stylers: [
        {
          saturation: '-100'
        }
      ]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [
        {
          saturation: '-3'
        },
        {
          color: '#e2e2e2'
        }
      ]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          saturation: '-100'
        }
      ]
    },
    {
      featureType: 'transit',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'transit',
      elementType: 'labels.icon',
      stylers: [
        {
          saturation: '-100'
        }
      ]
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          saturation: '-100'
        }
      ]
    }
  ];
  //Zoom level of google map
  public zoomLevel = 12;

  //center co-ordinates of google map
  public mapCenter = {lat: -33.868820, lng: 151.209296};
  // public apiKey = 'AIzaSyCn7W_eI1d6eih33tXq-2BZ595KEGIGfJ4';
  public numOfEmotions = 3;

  public currentLocationZoomLevel = 15;

  public defaultLocation: any = {lat: -33.875712, lng: 151.209204};
  public spaceDefaultLocation: any = {lat: -33.875712, lng: 151.209204};
  public yarningDefaultLocation: any = {lat: 24.9608843, lng: 55.1506911};
  // public spaceDefaultLocation: any = {lat: -42.90191216393451, lng: 147.3382490861504};
  //   147.3382490861504, -42.90191216393451

  public addReportDefaultLocation = {lat: -33.875712, lng: 151.209204};

  public engagementList: any[] = [
    'Contacted a politician, government, or local government official?',
    'Signed a petition/public letter?',
    'Donated money to a political organization or group?',
    'Created a protest placard',
    'Created a piece of political art/design',
    'Boycotted certain products?',
    'Worn/displayed a campaign badge/sticker?',
    'Raised awareness for a political issue via social media?',
    'Joined a peaceful strike (SS4C)?',
    'Taken part in direct action (such as: blockade, occupation, civil disobedience)?',
    'Used violent forms of action (against property or people)?',
    'Gave up a trip by plane for political, ethical or environmental reasons?',
    'Bought products for political, ethical or environmental reasons?',
    'Changed your diet for political, ethical or environmental reasons?',
    'Consumed less products altogether for political, ethical or environmental reasons?',
    'Reused products like bottles and plastic bags for political, ethical or environmental reasons?',
    'Reduced energy use in your household for political, ethical or environmental reasons?',
    'Bought second-hand goods (such as clothes, bikes, phones, etc.) for political, ethical or environmental reasons?'
  ];

  public emotionColors = {
    excited: '#FFFF00',
    happy: '#FFEC20',
    proud: '#FFE320',
    inspired: '#FFCA20',
    empowered: '#FFAF20',
    motivated: '#FF9725',
    joyful: '#FF7900',
    angry: '#D40100',
    fearful: '#EB0000',
    frustrated: '#FC4D4D',
    overwhelmed: '#F4845F',
    concerned: '#B0672A',
    threatened: '#8F5216',
    uneasy: '#6A3A01',
    content: '#000F98',
    surprised: '#002FE8',
    thoughtful: '#0266ED',
    amused: '#05ADD2',
    hopeful: '#02C389',
    reflective: '#09B846',
    safe: '#218300',
    depressed: '#8118BD',
    anxious: '#9000E2',
    worried: '#AB4DE0',
    sad: '#B579C8',
    powerless: '#A491B0',
    desperate: '#887498',
    displaced: '#736F76'
  };

  // public static markerRadius = [70, 35, 35];
  public markerRadius = [90, 60, 40];
  public markerSVGWidth = 200;
  public markerSVGHeight = 200;
  public markerCX = 95;
  // public static markerCX = 80;
  public markerCY = 95;
  // public static markerCY = 80;

  public agesGroup = [
    'all', '12 and under', '13-18', '19-25', '26-35', '36-45', '46-55', '55+'
  ];

  public genderGroup = [
    'all', 'male', 'female', 'other'
  ];

  public emotionsGroup = [
    'all', 'happy', 'excited', 'proud', 'content', 'thoughtful', 'surprised', 'sad', 'angry',
    'fearful', 'depressed', 'threatened', 'anxious'
  ];

  public emotions = [
    {
      id: 'excited',
      name: 'Excited',
      project: ['ic', 'yarn']
    },
    {
      id: 'happy',
      name: 'Happy',
      project: ['ic', 'paint', 'yarn']
    },
    {
      id: 'proud',
      name: 'Proud',
      project: ['ic', 'paint', 'codeRed', 'space', 'yarn', 'act']
    },
    {
      id: 'inspired',
      name: 'Inspired',
      project: ['paint']
    },
    {
      id: 'empowered',
      name: 'Empowered',
      project: ['yarn', 'codeRed', 'space', 'act']
    },
    {
      id: 'motivated',
      name: 'Motivated',
      project: ['codeRed', 'space', 'act']
    },
    {
      id: 'joyful',
      name: 'Joyful',
      project: ['codeRed', 'space', 'act']
    },
    {
      id: 'angry',
      name: 'Angry',
      project: ['codeRed', 'space', 'ic', 'yarn', 'paint', 'act']
    },
    {
      id: 'fearful',
      name: 'Fearful',
      project: ['codeRed', 'space', 'ic', 'act']
    },
    {
      id: 'frustrated',
      name: 'Frustrated',
      project: ['paint', 'codeRed', 'space', 'yarn', 'act']
    },
    {
      id: 'overwhelmed',
      name: 'Overwhelmed',
      project: ['codeRed', 'space', 'yarn', 'act']
    },
    {
      id: 'concerned',
      name: 'Concerned',
      project: ['paint']
    },
    {
      id: 'threatened',
      name: 'Threatened',
      project: ['ic']
    },
    {
      id: 'uneasy',
      name: 'Uneasy',
      project: ['yarn']
    },
    {
      id: 'content',
      name: 'Content',
      project: ['ic', 'paint', 'yarn']
    },
    {
      id: 'surprised',
      name: 'Surprised',
      project: ['ic', 'paint', 'yarn']
    },
    {
      id: 'thoughtful',
      name: 'Thoughtful',
      project: ['ic']
    },
    {
      id: 'amused',
      name: 'Amused',
      project: ['codeRed', 'space', 'act']
    },
    {
      id: 'hopeful',
      name: 'Hopeful',
      project: ['codeRed', 'space', 'act']
    },
    {
      id: 'reflective',
      name: 'Reflective',
      project: ['paint', 'codeRed', 'space', 'yarn', 'act']
    },
    {
      id: 'safe',
      name: 'Safe',
      project: ['codeRed', 'space', 'yarn', 'act']
    },
    {
      id: 'depressed',
      name: 'Depressed',
      project: ['ic']
    },
    {
      id: 'anxious',
      name: 'Anxious',
      project: ['ic', 'paint', 'codeRed', 'space', 'yarn', 'act']
    },
    {
      id: 'worried',
      name: 'Worried',
      project: ['codeRed', 'space', 'act']
    },
    {
      id: 'sad',
      name: 'Sad',
      project: ['ic', 'paint', 'yarn']
    },
    {
      id: 'powerless',
      name: 'Powerless',
      project: ['paint', 'codeRed', 'space', 'yarn', 'act']
    },
    {
      id: 'desperate',
      name: 'Desperate',
      project: ['codeRed', 'space', 'act']
    },
    {
      id: 'displaced',
      name: 'Displaced',
      project: ['yarn']
    }
  ];
}


